module.exports = __webpack_public_path__ + "static/media/icon_star_summary.95a4f545.svg";